import { UseQueryResult } from '@tanstack/react-query';
import { CollapseProps, Descriptions, Grid, Typography } from 'antd';
import { AxiosResponse } from 'axios';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import CollapseCustom from 'src/components/v2/Collapse';
import { HRTicketStatusTag } from 'src/components/v2/Tag/TicketStatusTag/TicketStatusTag';
import urlPath from 'src/constants/urlPath';
import { IAdvancePaymentTicket } from 'src/types/hr_ticket/advancePaymentTicket.type';
import { formatDate, formatDateTime } from 'src/utils/utils';
const { Text } = Typography;

const advancePaymentTicketItems = (
  advancePaymentTickets: IAdvancePaymentTicket[],
  colspan: number
): CollapseProps['items'] => {
  return advancePaymentTickets.map((item) => ({
    key: item.id,
    label: (
      <Descriptions
        layout='horizontal'
        labelStyle={{ width: '135px' }}
        column={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 2 }}
        key={item.id}
      >
        <Descriptions.Item label='Mã'>
          <Link to={`${urlPath.myAdvancePaymentTicket.location}/${item.id}`}>{item.code}</Link>
        </Descriptions.Item>
        <Descriptions.Item label='Trạng thái'>
          <HRTicketStatusTag ticketStatus={item.ticketStatus} />
        </Descriptions.Item>
        <Descriptions.Item label='Người lập phiếu'>
          <Text>{item.createdBy.fullName}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Ngày tạo'>
          <Text>{formatDateTime(item?.createdDate)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Người tạm ứng'>
          <Text>{item?.advancePaymentEmployee?.name}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Ngày yêu cầu'>
          <Text>{formatDate(item?.requestDate)}</Text>
        </Descriptions.Item>
        <Descriptions.Item label='Dòng tiền' span={colspan}>
          {item?.cashFlow}
        </Descriptions.Item>
        <Descriptions.Item label='Ghi chú' span={colspan}>
          <Text>{item.note}</Text>
        </Descriptions.Item>
      </Descriptions>
    ),
    showArrow: false,
    className: 'advance-payment-ticket-collapse-item'
  }));
};

export default function AdvancePaymentTicket(
  refAdvancePaymentTicketsForTicketQuery: UseQueryResult<AxiosResponse<IAdvancePaymentTicket[], any>, unknown>
) {
  const { useBreakpoint } = Grid;
  const breakpoints = useBreakpoint();
  const colspan = breakpoints.xxl ? 2 : 1;

  return (
    <Fragment>
      {refAdvancePaymentTicketsForTicketQuery?.data?.data &&
        refAdvancePaymentTicketsForTicketQuery?.data?.data.length > 0 && (
          <CollapseCustom
            isFullDefault
            title='Danh sách phiếu tạm ứng'
            titleLevel={5}
            collapsible='disabled'
            isSegmented={false}
            items={advancePaymentTicketItems(refAdvancePaymentTicketsForTicketQuery?.data.data || [], colspan)}
            expandIconPosition='end'
            className='advance-payment-ticket-collapse'
          />
        )}
    </Fragment>
  );
}
